import React from 'react';
import {Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap';
import {FormattedMessage} from 'react-intl';
import messages from '../../../res/translations/messages';

class SyncTrackersArchiveButton extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {modal: false};
        this.toggleModal = this.toggleModal.bind(this);
        this.onConfirm = this.onConfirm.bind(this);
    }

    toggleModal() {
        this.setState({modal: !this.state.modal});
    }

    onConfirm() {
        const {itemId, trackerArchiveFrequency, trackerArchiveFrequencyValue, onConfirm} = this.props;
        this.setState({modal: false}, () => {
            if (onConfirm) onConfirm(itemId, trackerArchiveFrequency, trackerArchiveFrequencyValue);
        });
    }

    render() {
        const {disabled} = this.props;
        return (
            <React.Fragment>
                <button type="button" className="btn btn-outline-secondary mt-3" disabled={disabled} onClick={!disabled ? this.toggleModal : undefined}>
                    <FormattedMessage {...messages.admin.organization.syncAllSurveysButton} />
                </button>
                <Modal isOpen={this.state.modal} toggle={this.toggleModal} size="lg">
                    <ModalHeader toggle={this.toggleModal}>
                        <FormattedMessage {...messages.admin.organization.syncAllSurveysModalTitle} />
                    </ModalHeader>
                    <ModalBody>
                        <FormattedMessage {...messages.admin.organization.syncAllSurveysModalBody} />
                    </ModalBody>
                    <ModalFooter>
                        <button className="btn btn-outline-secondary mr-auto" type="button" onClick={this.toggleModal}>
                            <FormattedMessage {...messages.buttons.cancel} />
                        </button>
                        <button className="btn btn-primary" type="button" onClick={this.onConfirm}>
                            <FormattedMessage {...messages.buttons.ok} />
                        </button>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        );
    }
}

export default SyncTrackersArchiveButton;
